export default __webpack_public_path__ + "static/media/hotel.1bb35249.png";